export const phoneNumber = (input: string) => {
  const cleanedInput = input.replace(/\D/g, ''); // 숫자 이외의 문자 제거
  const match = cleanedInput.match(/^(\d{3})(\d{3,4})(\d{4})$/);

  if (match) {
    return `${match[1]}-${match[2]}-${match[3]}`;
  }

  return input; // 형식에 맞지 않는 경우 그대로 반환
};

export const price = (price: number) => {
  if (!price) return;

  const formattedPrice = price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return formattedPrice;
};

export const format = Object.assign({ phone: phoneNumber, price });
